import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useHistory } from "react-router-dom";
import { notification } from "antd";
import { Routes } from "../../../../../AppRoutes";
import { EprCodeProcessService } from "../../../../../services/eprcode-process/eprcode-process.service";

export const useCreateEPR = () => {
  const queryClient = useQueryClient();
  const history = useHistory();

  const { mutate, ...restMutation } = useMutation({
    mutationFn: (body: any) => EprCodeProcessService.addEPRCodeRequest(body),
  });

  const createEPRRequest = (body: any, options?: { onSuccess?: (res: any) => void }) => {
    mutate(body, {
      onSuccess(res: any) {
        queryClient.invalidateQueries({ queryKey: ["epr-code-requests"] });
        history.push(Routes.processEprDetailPage.path.replace(":id", res.id));
        notification.success({
          message: "Thành công!",
          description: `Tạo yêu cầu thành công.`,
        });
        if (options?.onSuccess) options.onSuccess(res);
      },
      onError() {
        notification.error({
          message: "Thất bại",
          description: `Tạo yêu cầu thất bại.`,
        });
      },
    });
  };

  return { mutate, createEPRRequest, restMutation };
};
